module.exports = __webpack_public_path__ + "static/media/header.4d4f5730.png";